import React, { Component } from 'react'
import { connect } from 'react-redux'

import { UserBanner } from '../../features/users/userBanner'
import { fetchRefiTransaction } from './refiTransactionsActions'
import RefiTransactionsTodos from './refiTransactionsTodos'
import { selectRefiTransaction } from '../../reducers'
import { RefiTransactionsLoan } from './refiTransactionsLoan'
import { RefiTransactionsCurrentLoan } from './refiTransactionsCurrentLoan'
import { RefiTransactionsProducts } from './refiTransactionsProducts'
import { RefiTransactionsInfo } from './refiTransactionsInfo'
import { Documents } from '../common/docupload/documents'
import StatusBanner from '../common/statusBanner'
import { utcToLocalDateTimeFormat } from '../../helpers/timeHelper'
import { saveHistory } from '../../helpers/localStorageHelper'

import { RefiTransaction } from './types'

export type Callback<T = void> = (...args: any) => T
export interface Match<T> {
  params: T
}

export interface ParamsID {
  id: string
}

export interface Props {
  fetchRefiTransaction: Callback<Promise<any>>
  refiTransaction: RefiTransaction
  location: Location
  match: Match<ParamsID>
}

export class RefiTransactionsDetails extends Component<Props> {
  static displayName = 'RefiTransactionsDetails'

  componentDidMount() {
    this.fetchRefiAndSaveHistory()
  }

  fetchRefiAndSaveHistory = () => {
    const { location } = this.props
    return this.fetchRefi().then((refi) => {
      saveHistory(window.localStorage, 'refis', {
        pathname: location.pathname,
        name: refi.user.lastName,
        vin: refi.vehicle.vin,
        state: refi.user.activationState,
      })
    })
  }

  fetchRefi = () => {
    const { fetchRefiTransaction, match } = this.props
    return fetchRefiTransaction(match.params && match.params.id)
  }

  render() {
    const { refiTransaction } = this.props

    if (!refiTransaction.id) return null

    const soldDate = utcToLocalDateTimeFormat(refiTransaction.soldAt)

    return (
      <div className="refi-transaction-details">
        {refiTransaction.status === 'SOLD' && (
          <StatusBanner
            icon="other"
            status={refiTransaction.status}
            text={`This refinance transaction was completed on ${soldDate}.`}
          />
        )}
        {refiTransaction &&
          refiTransaction.loan &&
          refiTransaction.user &&
          refiTransaction.user.activationState && (
            <div>
              <div className="refi-transaction-details__applicant">
                <UserBanner
                  address={refiTransaction.user.currentAddress}
                  user={refiTransaction.user}
                  context="Applicant"
                />
              </div>
              <div>
                {refiTransaction.loan.coApplicant && (
                  <UserBanner
                    address={refiTransaction.loan.coApplicant.currentAddress}
                    user={refiTransaction.loan.coApplicant}
                    context="Co-Applicant"
                  />
                )}
              </div>
              <RefiTransactionsInfo refiTransaction={refiTransaction} />
              <div className="refi-transactions-underwriting">
                <div className="refi-transactions-underwriting__header">
                  Underwriting
                </div>
                <RefiTransactionsCurrentLoan
                  refiTransaction={refiTransaction}
                />
                <RefiTransactionsLoan refiTransaction={refiTransaction} />
              </div>
              <RefiTransactionsProducts refiTransaction={refiTransaction} />
              <div className="refi-transaction-details__todos">
                <div className="refi-transactions-details__todos--list">
                  <RefiTransactionsTodos
                    id={refiTransaction.id}
                    user={refiTransaction.user.name}
                  />
                </div>
                <div className="refi-transactions-details__todos--documents">
                  <Documents
                    id={refiTransaction.id}
                    items={refiTransaction.documents}
                    type="refi"
                  />
                </div>
              </div>
            </div>
          )}
      </div>
    )
  }
}

const mapStateToProps = (state, { match }: Props) => {
  return {
    refiTransaction: selectRefiTransaction(
      state.refiTransactions,
      match.params && match.params.id
    ),
  }
}

export default connect(mapStateToProps, { fetchRefiTransaction })(
  RefiTransactionsDetails
)
